import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { BaseResponse } from "../schemas/messaging";

export const usePutUnpinMessage = () => {
  const client = useApiClient();

  return useMutation<BaseResponse, Error, number>(messageID => client.putUnpinMessage(messageID));
};
